import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  helpIcon: {
    alignSelf: "center",
    marginLeft: 10,
  },
  addReviewerContainer: {
    marginTop: theme.spacing(2),
  },
}));

export default useStyles;
